// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Mixins **/
/** Vars (common) **/
/** app colors **/
/** Vars (MuiAlert) **/
/** main classes **/
.filters_old-container__X2Oca {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
  width: 100%;
}
.filters_old-container__X2Oca.filters_wrap__\\+C9dk {
  flex-wrap: wrap;
}
.filters_old-container__X2Oca .filters_box__C39KX.filters_col__DC0uB {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0 10px;
}
.filters_old-container__X2Oca .filters_box__C39KX.filters_col__DC0uB > div {
  width: 100%;
}
.filters_old-container__X2Oca .filters_box__C39KX.filters_row__vDNsk {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
}
.filters_old-container__X2Oca form {
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  flex-wrap: wrap;
  width: 100%;
}
.filters_old-container__X2Oca form > .filters_box__C39KX.filters_col__DC0uB {
  flex-basis: 33.33%;
}
@media screen and (min-width: 2560px) {
  .filters_old-container__X2Oca form > .filters_box__C39KX.filters_col__DC0uB {
    flex-basis: 0%;
    margin-right: 2em;
  }
}

@media screen and (max-width: 580px) {
  .filters_old-container__X2Oca, .filters_col__DC0uB, form {
    padding: 5px;
  }
}
@media screen and (max-width: 450px) {
  .filters_old-container__X2Oca, .filters_col__DC0uB, form {
    padding: 0px;
  }
}
.filters_text-overflow-hidden__kcbcN {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.filters_icon__vwDDf {
  color: var(--accent-color);
}

.filters_richtext-output-wrap__DtpWZ .filters_se-video-container__IdCJx figure {
  padding-bottom: 0 !important;
}

.filters_wrapper__3DtmE {
  min-width: 150px !important;
}

.filters_active__8Z1lI fieldset {
  border-color: var(--accent-color) !important;
}

.filters_search__YrInY {
  display: block;
  min-width: 180px;
  max-width: 180px;
}

.filters_dateRange__JZIza > div {
  background-color: #2F2F2F;
}
.filters_dateRange__JZIza > div > div > div:first-of-type > div:nth-of-type(2) > div {
  background-color: #2F2F2F;
}
.filters_dateRange__JZIza > div > div > div:first-of-type > div:nth-of-type(2) > div:nth-of-type(2) {
  background-color: #fff;
}
.filters_dateRange__JZIza > div > div > div:first-of-type > div:nth-of-type(2) > div button span p {
  color: #fff;
}
.filters_dateRange__JZIza > div > div > div:first-of-type > div:nth-of-type(2) > div button:disabled span p {
  color: #757575;
}
.filters_dateRange__JZIza > div > div > div:first-of-type > div:nth-of-type(2) > div button:hover {
  background-color: rgba(var(--accent-color-r), var(--accent-color-g), var(--accent-color-b), 0.04);
}
.filters_dateRange__JZIza h6, .filters_dateRange__JZIza svg, .filters_dateRange__JZIza span {
  color: #fff;
}
.filters_dateRange__JZIza div[role=button]:hover {
  background-color: rgba(var(--accent-color-r), var(--accent-color-g), var(--accent-color-b), 0.04);
}

.filters_cursorPointer__sZXBa {
  cursor: pointer;
}

.filters_withMaterialBorder__S2\\+OE {
  position: relative;
  padding: 0 10px;
  border-radius: 4px;
  border: 1px solid rgba(var(--accent-color-r), var(--accent-color-g), var(--accent-color-b), 0.25);
}
.filters_withMaterialBorder__S2\\+OE:hover {
  border-color: rgba(var(--accent-color-r), var(--accent-color-g), var(--accent-color-b), 0.5);
}
.filters_withMaterialBorder__S2\\+OE.filters_active__8Z1lI {
  border-color: rgba(var(--accent-color-r), var(--accent-color-g), var(--accent-color-b), 1);
}`, "",{"version":3,"sources":["webpack://./src/sass/_settings.sass","webpack://./src/components/common/NibTable/Filters/filters.module.sass"],"names":[],"mappings":"AAAA,aAAA;AAeA,oBAAA;AAgBA,iBAAA;AA0BA,sBAAA;AAGA,mBAAA;AACA;EA3DE,aAAA;EACA,mBA4DM;EA3DN,8BA2DW;EA1DX,uBA0D0B;EAC1B,kBAAA;EACA,WAAA;ACrDF;ADsDE;EACE,eAAA;ACpDJ;ADsDI;EAnEF,aAAA;EACA,sBAmEU;EAlEV,2BAkEkB;EAjElB,uBAiE8B;EAC1B,eAAA;ACjDN;ADkDM;EACE,WAAA;AChDR;ADiDI;EAxEF,aAAA;EACA,mBAwEU;EAvEV,2BAuEe;EAtEf,uBAsE2B;EACvB,WAAA;AC5CN;AD6CE;EACE,aAjDK;EA3BP,aAAA;EACA,mBA4EQ;EA3ER,2BA2Ea;EA1Eb,uBA0EyB;EACvB,kBAAA;EACA,eAAA;EACA,WAAA;ACxCJ;ADyCI;EACE,kBAAA;ACvCN;ADwCM;EAFF;IAGI,cAAA;IACA,iBAAA;ECrCN;AACF;;ADsCA;EAEE;IACE,YAFO;EClCT;AACF;ADoCA;EAEE;IACE,YAFO;ECjCT;AACF;ADoCA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AClCF;;ADoCA;EACE,0BAtFO;ACqDT;;ADqCI;EACE,4BAAA;AClCN;;AAxEA;EACI,2BAAA;AA2EJ;;AAxEI;EACI,4CAAA;AA2ER;;AAzEA;EAEI,cAAA;EACA,gBAFQ;EAGR,gBAHQ;AA8EZ;;AAxEI;EACI,yBDFD;AC6EP;AAvEoB;EACI,yBDPjB;ACgFP;AAxEwB;EACI,sBAAA;AA0E5B;AAzEwB;EACI,WAAA;AA2E5B;AA1EwB;EACI,cAAA;AA4E5B;AA3EwB;EACI,iGAAA;AA6E5B;AA5EI;EACI,WAAA;AA8ER;AA7EI;EACI,iGAAA;AA+ER;;AA7EA;EACI,eAAA;AAgFJ;;AA9EA;EACI,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iGAAA;AAiFJ;AAhFI;EACI,4FAAA;AAkFR;AAjFI;EACI,0FAAA;AAmFR","sourcesContent":["/** Mixins **/\n=flex($der, $justy, $align)\n  display: flex\n  flex-direction: $der\n  justify-content: $justy\n  align-items: $align\n\n=shadow()\n  box-shadow: -5px 5px 10px 0px rgba(#000, .35)\n\n=staticHeight($height)\n  min-height: $height\n  max-height: $height\n  height: $height\n\n/** Vars (common) **/\n$main: #2F2F2F\n$main_background: #191818\n$accent: var(--accent-color)\n$accent_text: var(--accent-text-color)\n$accent_r: var(--accent-color-r)\n$accent_g: var(--accent-color-g)\n$accent_g10: var(--accent-color-g10)\n$accent_b: var(--accent-color-b)\n$text: #cecece\n$error: #f44336\n$success: rgb(102, 187, 106)\n$container_background_color: #1B1B1B\n$container_item_background_color: #212121\n$gutter: 20px\n\n/** app colors **/\n$soft_teal: #84aaaf\n$fiery_red: #ff3131\n$muted_red: #e85a4f\n$app_red: #B83336\n$soft_creamy: #f5e8dd\n$light_gray: #535353\n$golden_yellow: #ffc107\n$orange: #ffa725\n$app_orange: #DB890E\n$warm_orange: #e3a869\n$faded_pink: #d69fa2\n$purple: #8868a3\n$app_purple: #7E51A3\n$light_blue: #79a8d1\n$app_green: #16962F\n$retro_green: #4a7c59\n$deep_blue: #406ca8\n\n$main_block_top_padding: 130px\n$main_block_top_padding_s: 70px\n$header_height: 120px\n$sidebar_width: 320px\n\n$table_row_height: 55px\n\n/** Vars (MuiAlert) **/\n$MuiAlert_main_color: rgb(166, 213, 250)\n\n/** main classes **/\n.old-container\n  //padding: $gutter\n  +flex(row, space-between, flex-start)\n  position: relative\n  width: 100%\n  &.wrap\n    flex-wrap: wrap\n  .box\n    &.col\n      +flex(column, flex-start, flex-start)\n      padding: 0 calc($gutter/2)\n      > div\n        width: 100%\n    &.row\n      +flex(row, flex-start, flex-start)\n      width: 100%\n  form\n    padding: $gutter\n    +flex(row, flex-start, flex-start)\n    position: relative\n    flex-wrap: wrap\n    width: 100%\n    > .box.col\n      flex-basis: 33.33%\n      @media screen and ( min-width: 2560px )\n        flex-basis: 0%\n        margin-right: 2em\n\n@media screen and ( max-width: 580px )\n  $gutter: 5px\n  .old-container, .col, form\n    padding: $gutter\n@media screen and ( max-width: 450px )\n  $gutter: 0px\n  .old-container, .col, form\n    padding: $gutter\n\n.text-overflow-hidden\n  overflow: hidden\n  text-overflow: ellipsis\n  white-space: nowrap\n\n.icon\n  color: $accent\n\n.richtext-output-wrap\n  .se-video-container\n    figure\n      padding-bottom: 0 !important\n","\n@import \"../../../../sass/_settings\"\n\n.wrapper\n    min-width: 150px !important\n\n.active\n    fieldset\n        border-color: $accent !important\n\n.search\n    $width: 180px\n    display: block\n    min-width: $width\n    max-width: $width\n\n.dateRange\n    >div\n        background-color: $main\n        > div\n            > div:first-of-type\n                > div:nth-of-type(2)\n                    > div\n                        background-color: $main\n                        &:nth-of-type(2)\n                            background-color: #fff\n                        button span p\n                            color: #fff\n                        button:disabled span p\n                            color: #757575\n                        button:hover\n                            background-color: rgba($accent_r, $accent_g, $accent_b, 0.04)\n    h6, svg, span\n        color: #fff\n    div[role=button]:hover\n        background-color: rgba($accent_r, $accent_g, $accent_b, 0.04)\n\n.cursorPointer\n    cursor: pointer\n\n.withMaterialBorder\n    position: relative\n    padding: 0 10px\n    border-radius: 4px\n    border: 1px solid rgba($accent_r, $accent_g, $accent_b, 0.25)\n    &:hover\n        border-color: rgba($accent_r, $accent_g, $accent_b, 0.5)\n    &.active\n        border-color: rgba($accent_r, $accent_g, $accent_b, 1)\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"old-container": `filters_old-container__X2Oca`,
	"wrap": `filters_wrap__+C9dk`,
	"box": `filters_box__C39KX`,
	"col": `filters_col__DC0uB`,
	"row": `filters_row__vDNsk`,
	"text-overflow-hidden": `filters_text-overflow-hidden__kcbcN`,
	"icon": `filters_icon__vwDDf`,
	"richtext-output-wrap": `filters_richtext-output-wrap__DtpWZ`,
	"se-video-container": `filters_se-video-container__IdCJx`,
	"wrapper": `filters_wrapper__3DtmE`,
	"active": `filters_active__8Z1lI`,
	"search": `filters_search__YrInY`,
	"dateRange": `filters_dateRange__JZIza`,
	"cursorPointer": `filters_cursorPointer__sZXBa`,
	"withMaterialBorder": `filters_withMaterialBorder__S2+OE`
};
export default ___CSS_LOADER_EXPORT___;
